var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgStepped = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentcolor",
  viewBox: "0 0 16 16",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M9.25 5.5a.75.75 0 0 1 .75-.75h4a.75.75 0 0 1 0 1.5h-3.25V8a.75.75 0 0 1-.75.75H6.75v1.75a.75.75 0 0 1-.75.75H2a.75.75 0 0 1 0-1.5h3.25V8A.75.75 0 0 1 6 7.25h3.25V5.5z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgStepped);
export default ForwardRef;